import { useEffect, useState } from 'react'

import { RecordFactory } from '../../models/RecordFactory'
import { Taxcode } from '../../models/Taxcode'
import Button from '../app/design/Button'
import Modal from '../app/design/Modal'
import SegmentedControl from '../app/design/SegmentedControl'
import { AddressPicker } from '../common/AddressPicker'
import { WorkflowIconSection } from './WorkflowIconSection'

type Props = {
    isOpen: boolean
    onClose: () => void
    nexus: '' | 'pro' | 'transaction'
    ownerTaxcode: Taxcode | undefined
    taxcode: Taxcode | undefined
    onChange: (nexus: '' | 'pro' | 'transaction', taxcode: Taxcode | undefined) => void
}

export const SalesTaxModal = ({
    isOpen,
    onClose,
    nexus,
    ownerTaxcode,
    taxcode,
    onChange,
}: Props) => {
    const [taxLocation, setTaxLocation] = useState('')

    const handleChangeNexus = (newNexus: string) => {
        if (newNexus !== '' && newNexus !== 'pro' && newNexus !== 'transaction') {
            return
        }

        setTaxLocation('')
        onChange(newNexus, newNexus === 'pro' ? ownerTaxcode : undefined)
    }

    useEffect(() => {
        if (nexus !== 'transaction' || !taxLocation) {
            return
        }

        ;(async () => {
            const result = await RecordFactory.getInstance().queryTaxcode(taxLocation)
            if (!result.ok) {
                return
            }

            onChange(nexus, result.value ?? undefined)
        })()
    }, [nexus, taxLocation])

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            title="Sales tax"
            footer={
                <div className="flex justify-end">
                    <Button intent="primary" onClick={onClose}>
                        Done
                    </Button>
                </div>
            }
            width={744}
        >
            <WorkflowIconSection title="Sales tax" icon="percentage2.large">
                <SegmentedControl
                    segments={[
                        { label: "Don't collect", value: '' },
                        { label: 'At business location', value: 'pro' },
                        { label: 'At transaction location', value: 'transaction' },
                    ]}
                    value={nexus}
                    onChange={handleChangeNexus}
                    size="medium"
                />

                {nexus === 'transaction' && (
                    <AddressPicker
                        size="medium"
                        placeholder="Enter an address"
                        onSelect={setTaxLocation}
                    />
                )}

                {nexus !== '' && taxcode !== undefined && (
                    <div className="flex items-center justify-center gap-x-1 rounded-lg border border-gray-300 p-4">
                        <span className="font-bold">{taxcode.rate ?? 0}%</span>
                        {taxcode.state && <span className="text-gray-600">({taxcode.state})</span>}
                    </div>
                )}
            </WorkflowIconSection>
        </Modal>
    )
}
